import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import TranslateText from 'components/hoc/TranslateText';
import React from 'react';

const TitleAnt = Typography.Title;

interface ITitle extends TitleProps {
    text: string;
    level: 1 | 2 | 3 | 4 | 5;
}

const Title: React.FC<ITitle> = props => {
    return (
        <TitleAnt {...props} level={props.level} className="title">
            <TranslateText>{props.text}</TranslateText>
        </TitleAnt>
    );
};

export default Title;
